/**
 * The Slate's `Element.isElement()` is explicitly excluding `Editor`.
 */
export function isElementOrEditor(node) {
  return 'children' in node;
}